export default function LeaveStatusBadge({
  status,
}) {
  const styles = {
    Pending:
      "bg-yellow-100 text-yellow-700",

    Approved:
      "bg-green-100 text-green-700",

    Rejected:
      "bg-red-100 text-red-700",
  };

  return (
    <span
      className={`
        inline-flex
        items-center
        px-3
        py-1
        rounded-full
        text-xs
        font-semibold
        ${
          styles[status] ||
          "bg-gray-100 text-gray-700"
        }
      `}
    >
      {status}
    </span>
  );
}